var map = {
	"./Caminos desactivado.svg": "sj+g",
	"./Caminos.svg": "i4hj",
	"./Edificios desactivado.svg": "eyRa",
	"./Edificios.svg": "hBbJ",
	"./Logo DNCP.svg": "TI/u",
	"./Otros desactivado.svg": "na2Z",
	"./Otros.svg": "LgMl",
	"./Puentes desactivado.svg": "9muk",
	"./Puentes.svg": "Gifx",
	"./close-button.png": "RpXo",
	"./datos-abiertos.png": "EsuS"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "F3Gc";